import React, { useState, useEffect } from "react";
import services from "data/Home/services.json";
import "./style.css";
import withDimension from "utils/withDimension";
import { MAX_RESPONSIVE_MOBILE } from "store/constants";
import HomeServiceDesktop from "./HomeServiceDesktop";
import HomeServiceMobile from "./HomeServiceMobile";
import { getServicesType } from "services/Homepage";

const HomeServices = (props) => {
  const [serviceList, setServiceList] = useState(null);

  async function fetchBanner() {
    const result = await getServicesType();

    setServiceList(result);
  }

  useEffect(() => {
    fetchBanner();
  }, []);

  return (
    <div className="w-full md:max-w-[1328px] md:mx-auto md:px-16 relative z-10 md:mt-[-237px]">
      <div className="w-full relative">
        <div className="pt-[65px] md:pt-[40px] py-[40px] px-16 md:p-0">
          <h1 className="text-[48px] leading-[80%] text-neutral-100 font-taviraj text-center md:mb-32">
            Our Services
          </h1>
        </div>
        {props.windowDimension.width > MAX_RESPONSIVE_MOBILE ? (
          <HomeServiceDesktop services={serviceList} />
        ) : (
          <HomeServiceMobile services={serviceList} />
        )}
      </div>
    </div>
  );
};

export default withDimension(HomeServices);
